import * as React from 'react';
import { useEffect, useState } from 'react';
import store from "../../../storeWire";
import { SET_CART_READY_TO_GO_FOR_CHECKOUT } from "../../../store/slice/model/Cart";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import useDebounce from "../../../hooks/useDebounce";
import Helper from "../../../support/Helper";
import Common from "../Common";
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const Notification = ({ setProductAvailableError }) => {
    const [{ CART_DATA, CART_PRODUCT_DATA, CART_PRODUCT_INVENTORY_DATA }, { }, { }] = useCartStore();
    const [inventoryOutOfStock, setInventoryOutOfStock] = useState(false);
    const [shippingApplicable, setShippingApplicable] = useDebounce(false, 500);
    const [productAvailableFromMainAPI_trigger, setProductAvailableFromMainAPI_trigger] = useDebounce(false, 500);
    const [productAvailableFromMainAPI, setProductAvailableFromMainAPI] = useDebounce(false, 500);
    const [productNCRT, setProductNCRT] = useDebounce(false, 400);
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();

    const checkInventoryOutOfStockValidation = () => {
        setInventoryOutOfStock(new Common().getInventoryOutOfStockFlag(CART_DATA, CART_PRODUCT_DATA));
    };

    const checkShippingApplicableValidation = () => {
        if (CART_DATA !== undefined && CART_DATA && CART_DATA.length > 0) {
            setShippingApplicable(false);
            let isBroken = false;
            CART_DATA.map((res) => {
                if (isBroken) {
                    return;
                }
                if (res.isEligibleShipping === false) {
                    setShippingApplicable(true);
                    isBroken = true;
                    return;
                }
            })
        } else {
            setShippingApplicable(false);
        }
    }

    const checkProductAvailableFromMainAPIValidation = () => {
        if (CART_DATA !== undefined && CART_DATA && CART_DATA.length > 0) {
            setProductAvailableFromMainAPI(false);
            let isBroken = false;
            CART_DATA.map((res) => {
                if (isBroken) {
                    return;
                }
                if (res.isProductAvailableFromMainAPI === false) {
                    setProductAvailableFromMainAPI(true);
                    isBroken = true;
                    return;
                }
            })
        } else {
            setProductAvailableFromMainAPI(false);
        }
    }

    const checkProductNCRTValidation = () => {
        if (CART_PRODUCT_DATA !== undefined && CART_PRODUCT_DATA && Object.entries(CART_PRODUCT_DATA).length > 0) {
            setProductNCRT(false);
            let isBroken_CART_PRODUCT_DATA = false;
            Object.entries(CART_PRODUCT_DATA).map((res) => {
                if (isBroken_CART_PRODUCT_DATA) {
                    return;
                }
                if (res[1].NCNRFlag === true) {
                    setProductNCRT(true);
                    isBroken_CART_PRODUCT_DATA = true;
                    return;
                }
            })
        }
    };

    const changeCheckoutFlat = (status) => {
        status = !status;
        store.dispatch(SET_CART_READY_TO_GO_FOR_CHECKOUT({ status }));
    };

    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        if (__check('CART_API_CALL_ON_PAGE_LOADING').status === true) {
            setTimeout(() => {
                setProductAvailableFromMainAPI_trigger(Helper.UUID())
            }, 3000)
        }
        if (__check('CART_API_CALL_ON_PAGE_LOADING').status === false) {
            setProductAvailableFromMainAPI_trigger(Helper.UUID())
        }
    }, [CART_PRODUCT_INVENTORY_DATA]);

    useEffect(() => {
        if (productAvailableFromMainAPI_trigger !== false) {
            checkInventoryOutOfStockValidation()
        }
    }, [productAvailableFromMainAPI_trigger]);

    useEffect(() => {
        checkProductAvailableFromMainAPIValidation()
        checkShippingApplicableValidation()
        checkInventoryOutOfStockValidation()
    }, [CART_DATA]);

    useEffect(() => {
        if (productAvailableFromMainAPI === false) {
            changeCheckoutFlat(inventoryOutOfStock)
        }
    }, [inventoryOutOfStock]);

    useEffect(() => {
        setProductAvailableError(false)
        if (productAvailableFromMainAPI === false) {
            changeCheckoutFlat(shippingApplicable)
            if (shippingApplicable) {
                setProductAvailableError(true)
            }
        }
    }, [shippingApplicable]);

    // useEffect(() => {
    //     setProductAvailableError(false)
    //     if (shippingApplicable && productAvailableFromMainAPI === false) {
    //         setProductAvailableError(true)
    //     }
    // }, [shippingApplicable])

    useEffect(() => {
        if (productAvailableFromMainAPI === true) {
            store.dispatch(SET_CART_READY_TO_GO_FOR_CHECKOUT({ status: false }));
            System.alert('You have item(s) in your cart that can no longer be purchased from our site. Please remove item(s) from cart to Checkout.', 'danger')
        }
    }, [productAvailableFromMainAPI]);

    useEffect(() => {
        checkProductNCRTValidation()
    }, [latest_system_notification_data, CART_PRODUCT_DATA]);

    useEffect(() => {
        if (productNCRT && productAvailableFromMainAPI === false) {
            System.alert('Your cart contains <b>NCNR:</b> <span>Non-Cancelable/Non-Returnable parts.</span>', 'warning')
        }
    }, [productNCRT])

    // useEffect(() => {
    //     if (productAvailableFromMainAPI) {
    //         System.alert('You have item(s) in your cart that can no longer be purchased from our site. Please remove item(s) from cart to Checkout.', 'danger')
    //     }
    // }, [productAvailableFromMainAPI])

    return (
        <>
        </>
    );
}

export default Notification;